import { LoggedOutPageContainer } from "components/pageLayouts/pageLayouts.styled";
import { useCompanyStore } from "web-apps/company/stores/companyStore/companyStore";
import { CircularProgress } from "@material-ui/core";
import { StatusBanner } from "components/designV2/statusBanner/statusBanner";
import { ColorV2 } from "config/colors";
import { useTranslation } from "react-i18next";
import { SalaryTabs } from "web-apps/company/components/salary/salaryTabs.component";
import { PageContainer } from "components/designV2/layout/grid";
import styled from "styled-components";

export const SalaryPage = (): JSX.Element => {
  const [companyState] = useCompanyStore();
  const [authState] = useCompanyStore();
  const { t } = useTranslation();

  return (
    <Page>
      <PageContainer>
          {authState.isLoading || companyState.isLoading ? (
            <LoggedOutPageContainer>
              <CircularProgress />
            </LoggedOutPageContainer>
          ) : companyState.company?.verified ? (
            <SalaryTabs />
          ) : (
            <StatusBanner
              iconName="v2/clock"
              label={t("GigsCompany.UnverifiedAccount")}
              subLabel={t("GigsCompany.UnverifiedAccountDetails")}
              textColor={ColorV2.NegativeRed}
              backgroundColor={ColorV2.White}
            />
          )}
      </PageContainer>
    </Page>
  );
};

const Page = styled.div`
  background-color: ${ColorV2.Blue7};
  min-height: 100vh;
  width: 100%;
  padding-top: 100px;
`;